import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ScheduleProvider } from './context/ScheduleContext';
import { NoticeProvider } from './context/NoticeContext';
import Login from './components/Login';
import Calendar from './Calendar';

const AppContent: React.FC = () => {
  const { isLoggedIn } = useAuth();

  return isLoggedIn ? <Calendar /> : <Login />;
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      {({ isLoggedIn }) =>
        isLoggedIn ? (
          <ScheduleProvider>
            <NoticeProvider>
              <AppContent />
            </NoticeProvider>
          </ScheduleProvider>
        ) : (
          <Login />
        )
      }
    </AuthProvider>
  );
};

export default App;
